import BindWechat from './src/main'

export default {
  install(Vue, props) {
    Vue.prototype.$BindWechat = options => BindWechat(options, props)
  }
}
